export const buildAresDeploymentGroupInstalledCompaniesRoute = (groupId?: number) =>
    "/ares-deployments/installed-companies" + (groupId ? `?groupId=${groupId}` : "");
